import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-cream text-pitch" data-id="element-46" data-mp="1ntzxx8rhxr1b">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-5" data-id="element-47" data-mp="2bkcbp09fahzt">
        <h2 id="faq" className="text-center font-display text-[1.8rem] font-normal uppercase leading-none sm:text-5xl" data-id="element-48" data-mp="2bkvv6leq1efy">
          Preguntas frecuentes
        </h2>

        <div className="mt-3 space-y-1.5" data-id="element-49" data-mp="21u19bi5e0gv1">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border-2 bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-field' : 'border-pitch/15'}`} data-id="element-50" data-mp="2uj8363twci9y" data-mpi={i}>
                <h3 data-id="element-51" data-mp="1vqkn8doo26bx">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-2.5 rounded-xl px-3 py-2 text-left" data-id="element-52" data-mp="1vq15awz0nhxw">
                    <span className="font-sub text-sm font-extrabold leading-snug" data-id="element-53" data-mp="2fcz1htdcvkgu">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-field transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-54" data-mp="2aedxrjywainn" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="u28n1zict7aa">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-56" data-mp="p3fcaeugbudt">
                      <p className="px-3 pb-2 text-sm leading-snug text-pitch/80" data-id="element-57" data-mp="334oc3dgmyhui">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}